import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { PageTemplateContent } from 'app/common/templates-next/page-template'
import EmptyWarn from 'app/common/layouts/EmptyWarn'
import { getIsStudent } from 'app/selectors/user'

import styles from './FinancesPageRoot.scss'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const FinancesPageRoot = ({ children }: Props) => {
  const { t } = useTranslation('finances')
  const isStudent = useSelector(getIsStudent)

  if (isStudent) {
    return (
      <PageTemplateContent className={styles.restrictedMessage} skipPadding>
        <EmptyWarn>{t('student_denied', 'Страница доступна только для родителей')}</EmptyWarn>
      </PageTemplateContent>
    )
  }

  return children
}
